import { render, staticRenderFns } from "./TemplateObjectEditor.vue?vue&type=template&id=152f1aee&scoped=true"
import script from "./TemplateObjectEditor.vue?vue&type=script&lang=js"
export * from "./TemplateObjectEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateObjectEditor.vue?vue&type=style&index=0&id=152f1aee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f1aee",
  null
  
)

export default component.exports